import { z } from 'zod'

export const couponTabSchema = z.enum(['available', 'history'])

export const COUPON_TAB = {
  AVAILABLE: couponTabSchema.enum.available,
  HISTORY: couponTabSchema.enum.history,
} as const

export type CouponTab = (typeof COUPON_TAB)[keyof typeof COUPON_TAB]
